export default class ViewLevelManager {
  private scaleFactor: number;
  private minDocumentCardThreshold: number;
  private minDocumentTitleThreshold: number;
  private subTopicMinThreshold: number;
  private subTopicMaxThreshold: number;
  private topicMaxThreshold: number;
  private documentPointMaxThreshold: number;
  private documentPointMinThreshold: number;

  constructor({
    scaleFactor = 1,
    minDocumentCardThreshold = 1,
    minDocumentTitleThreshold = 1,
    subTopicMinThreshold = 1,
    subTopicMaxThreshold = 1,
    topicMaxThreshold = 1,
    documentPointMaxThreshold = 1,
    documentPointMinThreshold = 1,
  }) {
    this.scaleFactor = scaleFactor;
    this.minDocumentCardThreshold = minDocumentCardThreshold;
    this.minDocumentTitleThreshold = minDocumentTitleThreshold;
    this.subTopicMinThreshold = subTopicMinThreshold;
    this.subTopicMaxThreshold = subTopicMaxThreshold;
    this.topicMaxThreshold = topicMaxThreshold;
    this.documentPointMaxThreshold = documentPointMaxThreshold;
    this.documentPointMinThreshold = documentPointMinThreshold;
  }

  getDynamicZoomLevel(transform) {
    return transform.k * this.scaleFactor;
  }

  showGridPoints(transform) {
    return this.getDynamicZoomLevel(transform) > this.minDocumentCardThreshold;
  }

  showDocumentPoints(transform) {
    return (
      this.getDynamicZoomLevel(transform) > this.documentPointMinThreshold &&
      this.getDynamicZoomLevel(transform) < this.documentPointMaxThreshold
    );
  }

  showWordPoints(transform) {
    return this.getDynamicZoomLevel(transform) < this.documentPointMaxThreshold;
  }

  isInitialZoom(transform) {
    return transform.k <= 1;
  }

  showDocumentCards(transform) {
    return (
      !this.isInitialZoom(transform) &&
      this.getDynamicZoomLevel(transform) > this.minDocumentCardThreshold
    );
  }

  showTopics(transform) {
    return (
      this.isInitialZoom(transform) ||
      this.getDynamicZoomLevel(transform) < this.topicMaxThreshold
    );
  }

  showDocumentTitle(transform) {
    return this.getDynamicZoomLevel(transform) > this.minDocumentTitleThreshold;
  }

  showSubTopics(transform) {
    return (
      !this.isInitialZoom(transform) &&
      this.getDynamicZoomLevel(transform) > this.subTopicMinThreshold &&
      this.getDynamicZoomLevel(transform) < this.subTopicMaxThreshold
    );
  }

  showDocumentGroups(transform) {
    return this.getDynamicZoomLevel(transform) < this.documentPointMinThreshold;
  }
}
